<template>
    <div class="ClassList">
        <filters/>
        <template v-if="classList && classList.length">
            <div class="d-flex justify-content-center">
                <div class="w-100 mx-1"
                     v-for="(cartColumn, index) of classesMatrix"
                     :key="index"
                >
                    <div class="mb-4"
                         v-for="activity of cartColumn"
                         :key="activity.id"
                    >
                        <class-cart
                                :activity="activity"
                                :is-public="isPublic"
                                @open="onEnrollButtonClick(activity)"
                        />
                    </div>
                </div>
            </div>
            <pagination/>
        </template>
        <template v-else>
            <no-data-skeleton v-if="!searchQuery"/>
            <template v-else>
                <div class="not-found">
                    <img src="../../../../assets/img/ilustra-empty-search.png">
                    Oh no! We can’t find any activities with that name :|
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import * as types from '@/store/mutationTypes';
    import { mapActions, mapMutations, mapGetters } from 'vuex';
    import { EventListenerMixin } from '@/mixins/EventListenerMixin';

    const COLUMN_COUNT_RATIO = 430;
    const SIDEBAR_SIZE = 280;

    const ActivityClassSetUpChildModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/ActivityClassSetUpChildModal');
    const SelectPaymentCardModal = () => import(/* webpackChunkName: "activities" */ '@/components/modals/SelectPaymentCardModal');

    export default {
        name: 'ClassList',

        components: {
            ClassCart: () => import(/* webpackChunkName: "activities" */ '@/components/dashboard/pages/Activities/ClassCart'),
            NoDataSkeleton: () => import(/* webpackChunkName: "activities" */ '@/components/controls/NoDataSkeleton'),
            Pagination: () => import(/* webpackChunkName: "activities" */ '@/components/controls/Pagination'),
            Filters: () => import(/* webpackChunkName: "activities" */ '@/components/controls/Filters')
        },

        mixins: [EventListenerMixin('resize', 'onWatchWindowWidth')],

        data() {
            return {
                windowWidth: null
            }
        },

        props: {
            isPublic: {
                type: Boolean,
                default: false
            },
            isSchool: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            ...mapGetters(['classList', 'isMobile', 'searchQuery', 'schoolInfo']),

            classesMatrix() {
                const cartsMatrix = [];
                let columnCount;

                if (this.isMobile) {
                    columnCount = Math.floor(this.windowWidth / COLUMN_COUNT_RATIO);

                    if (!columnCount) {
                        columnCount = 1;
                    }

                } else {
                    if ( window.location !== window.parent.location ) {
                        columnCount = Math.round(this.windowWidth / COLUMN_COUNT_RATIO);
                    } else {
                        columnCount = Math.round((this.windowWidth - SIDEBAR_SIZE) / COLUMN_COUNT_RATIO);
                    }
                }

                for (let i = 0; i < columnCount; i++) {
                    let column = [];

                    for (let j = i; j < this.classList.length; j += columnCount) {
                        column.push(this.classList[j]);
                    }

                    cartsMatrix.push(column);
                }

                return cartsMatrix;
            }
        },

        methods: {
            ...mapActions([
                'getClassesBySchool',
                'openModal',
                'setPayNowActivityId',
                'setPayNowEnrollemtData',
                'checkClassRoster',
                'cancelWaitlistPaymentFlow',
                'checkAftercareRoster',
                'checkCampRoster'
            ]),

            ...mapMutations({
                setClass: types.SET_ACTIVITY
            }),

            openEnrollChildModal(activity) {
                this.setClass(activity);
                this.openModal({
                    modal: ActivityClassSetUpChildModal,
                    options: {
                        isSchool: this.isSchool
                    }
                });
            },

            redirectToParentPortal(activity) {
                const { school } = this.$router.currentRoute.params;
                window.open(`${window.location.origin}/parents/${school}/activities?activeTab=ClassList&classId=${activity.id}`, '_blank');
            },

            onEnrollButtonClick(activity) {
                this.isPublic ? this.redirectToParentPortal(activity) : this.openEnrollChildModal(activity);
            },

            findActivityById(id) {
                return _.find(this.classList, activity => activity.id === +id);
            },

            onWatchWindowWidth() {
                this.windowWidth = window.innerWidth;
            }
        },
        async beforeMount() {
            const { redirect_status, rosterDay, activityId, defaultMethod, typeActivity, roster, activityType, child, campId, campPricingId, classId, aftercareId , cancellation } = this.$router.currentRoute.query;
            if (roster && activityType) {
                let activityId;

                switch (activityType) {
                    case 'class':
                        activityId = classId;
                        break;
                    case 'camp':
                        activityId = cancellation ? campPricingId : campId;
                        break;
                    case 'aftercare':
                        activityId = aftercareId;
                        break;
                }
                try {

                if (activityType === 'class') {
                    await this.checkClassRoster({
                        schoolId: this.schoolInfo.id,
                        classId: classId,
                        rosterId: roster,
                        childId: child
                    });  
                }
                
                if (activityType === 'camp') {
                    await this.checkCampRoster({
                        schoolId: this.schoolInfo.id,
                        campPricingId: activityId,
                        rosterId: roster,
                        childId: child
                    });  
                }

                if (activityType === 'aftercare') {
                    const payload = {
                        schoolId: this.schoolInfo.id,
                        aftercareId: aftercareId,
                        rosterId: roster,
                        rosterDayId: rosterDay,
                        childId: child
                    }
                    await this.checkAftercareRoster(payload);  
                }

                this.setPayNowActivityId(roster);
                this.setPayNowEnrollemtData({ activityId, activityType: activityType.charAt(0).toUpperCase() + activityType.slice(1), childId: child, campPricingId });
                if (cancellation){
                    this.cancelWaitlistPaymentFlow(rosterDay)
                    return
                }
                this.openModal({
                    modal: SelectPaymentCardModal,
                    options: {
                        confirmOnClose: true,
                        setDefaultMethod: false,
                        isWaitlistFlow: true,
                        rosterDay: rosterDay
                    }
                });
                } catch (error) {
                    console.log(error);
                } finally {
                    this.$router.replace({'query': null});
                    localStorage.removeItem('query');
                    localStorage.removeItem('router-name');
                    return;
                }
            }


            if (redirect_status === 'succeeded') {
                this.setPayNowActivityId(activityId)
                this.setPayNowEnrollemtData({ activityType: typeActivity });
                this.openModal({
                    modal: SelectPaymentCardModal,
                    options: {
                        confirmOnClose: true,
                        setDefaultMethod: defaultMethod === 'true'
                    }
                });
                this.$router.replace({'query': null});
            }  
        },

        async created() {
            const { classId, roster } = this.$route.query;
            await this.getClassesBySchool();

            if (classId && !roster) {
                await this.$nextTick();
                const activity = this.findActivityById(classId);
                activity && this.openEnrollChildModal(activity);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Activities/ClassList.vue